import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {
  itemsOfContentSelector,
  activeItemNameOfContentSelector,
  changeItem as changeItemAC,
  titleOfContentSelector
} from "../../ducks/content";
import Sidebar from "../Sidebar";

import styles from "./category-sidebar.module.scss";

function CategorySidebar({items, activeItem, title, changeItem}) {
  const handleClick = (name) => (event) => {
    event.preventDefault();
    changeItem(name);
  };
  return (
    <div className={styles.root}>
      <Sidebar
        items={[
          {
            title,
            children: items
          }
        ]}
        activeItem={activeItem}
        onClick={handleClick}
      />
    </div>
  );
}

CategorySidebar.propTypes = {
  items: PropTypes.array,
  activeItem: PropTypes.string,
  title: PropTypes.string,
  changeItem: PropTypes.func
};

const mapStateToProps = (state) => ({
  items: itemsOfContentSelector(state),
  activeItem: activeItemNameOfContentSelector(state),
  title: titleOfContentSelector(state)
});

export default connect(mapStateToProps, {
  changeItem: changeItemAC
})(CategorySidebar);
